import instance from "../../utils/instance";

class WorkFlowService {
    async getFormFieldsOptions(workflowTemplateId,style,dict) {
        return await instance.get('/wf/form/node/getFormFieldsOptions?workflowTemplateId='+workflowTemplateId+"&style="+(style || "")+"&dict="+(dict || ""));
    }
    async getFormFields(workflowTemplateId) {
        return await instance.get('/wf/form/workflowConfig/getFormFields?workflowTemplateId='+workflowTemplateId);
    }
}

export default new WorkFlowService();